import React from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import StudentProfileHeaderCustomElements from "../../../../components/PagesComponents/Operational/Academic/Students/StudentProfileHeaderCustomElements.component";
import "../../../../styles/Pages/Operational/Academic/Students/StudentProfile.style.css";
import StudentProfileOverview from "../../../../components/PagesComponents/Operational/Academic/Students/StudentProfileOverview";
import StudentsStore from "../../../../store/Academic/Students.store";
import StudentAttendance from "../../../../components/PagesComponents/Operational/Academic/Students/StudentAttendance.component";
import PerformanceReport from "../../../../components/PagesComponents/Operational/Academic/Students/PerformanceReport.component";
const Body = ({ studentsData, convertToTitleCase, grades, gradeSystem }) => {
  studentsData = studentsData[0];
  const { setCurrentPage, currentPage } = StudentsStore();
  const changeReports = () => {
    if (currentPage === "" || currentPage === "overview") {
      return (
        <StudentProfileOverview
          studentsData={studentsData && studentsData}
          convertToTitleCase={convertToTitleCase}
        />
      );
    } else if (currentPage === "attendance") {
      return (
        <StudentAttendance
          studentData={studentsData && studentsData}
          convertToTitleCase={convertToTitleCase}
        />
      );
    } else if (currentPage === "performance") {
      return (
        <PerformanceReport
          studentData={studentsData && { ...studentsData, grades: grades }}
          convertToTitleCase={convertToTitleCase}
          gradeSystem={gradeSystem}
        />
      );
    } else if (currentPage === "report") {
      return "report";
    }
  };
  return (
    <section className="studentsProfile p-r-05">
      <PageHeader
        renderCustomElement={
          <StudentProfileHeaderCustomElements
            changePage={setCurrentPage}
            currentPage={currentPage}
          />
        }
      />
      {changeReports()}
    </section>
  );
};

export default Body;
